import { render, staticRenderFns } from "./CustomerCreditNoteList.vue?vue&type=template&id=68d09454&scoped=true&"
import script from "./CustomerCreditNoteList.vue?vue&type=script&lang=js&"
export * from "./CustomerCreditNoteList.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCreditNoteList.vue?vue&type=style&index=0&id=68d09454&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d09454",
  null
  
)

export default component.exports